
import { Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';


export default function Banner() {



    return(
        
      
        <Row> 
            <Col className="p-5 bkg-light my-5 rounded" align="center">

              <>
                <h1 className="text-light">Welcome To ZOOKI Shopping Website</h1>
                <Button className="text-light mt-3" as={Link} to='/product' variant='dark'>View Products</Button>
                
                </>
              
            </Col>
        </Row>
       
        
)};


